import { httpClient, ApiResponse } from '@/utils';
import { AuthEndpoints, IAuthResponse, IForgotPasswordDTO, ILoginDTO, IResetPasswordDTO } from '@/models/auth.model';

class AuthAPI {
  static login(data: ILoginDTO): ApiResponse<IAuthResponse> {
    return httpClient.post<IAuthResponse>(AuthEndpoints.LOGIN, data);
  }

  static logout(): ApiResponse<IAuthResponse> {
    return httpClient.post<IAuthResponse>(AuthEndpoints.LOGOUT);
  }

  static forgotPassword(data: IForgotPasswordDTO): ApiResponse<unknown> {
    return httpClient.post<unknown>(AuthEndpoints.FORGOT_PASSWORD, data);
  }

  static resetPassword(data: IResetPasswordDTO): ApiResponse<unknown> {
    return httpClient.post<unknown>(AuthEndpoints.RESET_PASSWORD, data);
  }
}

export default AuthAPI;
